export class ChatStyles {
  static get() {
    return `
        :host {
          all: initial; /* Prevent inheriting styles from host page */
          position: fixed;
          bottom: var(--ctm-chat-bottom-offset, 24px);
          right: var(--ctm-chat-right-offset, 24px);
          z-index: var(--ctm-chat-z-index, 9999);
          font-family: var(--ctm-chat-font-family, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif);
          font-size: 16px;
          line-height: 1.5;
          transition: opacity 0.3s ease, transform 0.3s ease;
          /* Start hidden to prevent flicker before schedule check */
          opacity: 0;
          pointer-events: none;
           --primary-color: var(--ctm-chat-primary-color, var(--ctm-chat-primary-color-default));
           --primary-color-dark: var(--ctm-chat-primary-color-dark, var(--ctm-chat-primary-color-dark-default));
           --text-color: var(--ctm-chat-text-color, #333);
           --bg-color: var(--ctm-chat-bg-color, #ffffff);
           --bubble-size: var(--ctm-chat-bubble-size, var(--ctm-chat-bubble-size-default));
           --bubble-icon-size: var(--ctm-chat-bubble-icon-size, var(--ctm-chat-bubble-icon-size-default));
           --window-width: var(--ctm-chat-window-width, var(--ctm-chat-window-width-default));
           --window-height: var(--ctm-chat-window-height, var(--ctm-chat-height-width-default));
           --window-max-height: var(--ctm-chat-window-max-height, 80vh); /* Max height relative to viewport */
           --header-height: 50px;
           --input-area-height: 50px;
        }
        
        /* Show widget after initialization */
        :host(.initialized) {
          opacity: 1;
          pointer-events: auto;
          position: fixed;
          bottom: var(--ctm-chat-bottom-offset, 24px);
          right: var(--ctm-chat-right-offset, 24px);
        }

        /* Contained placement fills and anchors to a positioned ancestor. */
        :host([placement="contained"]),
        :host([placement="contained"].initialized) {
          position: absolute;
          inset: 0;
          display: block;
        }

        /*
         * Natural placement participates in page layout wherever the host is
         * inserted while its open window remains an overlapping layer.
         */
        :host([placement="natural"]),
        :host([placement="natural"].initialized) {
          position: relative;
          inset: auto;
          display: inline-block;
        }
        
        /* Hide widget when schedule is not active */
        :host(.schedule-hidden) {
          opacity: 0;
          transform: scale(0.8);
          pointer-events: none;
        }
        
        /* Keep widget visible if there's an active chat */
        :host(.schedule-hidden.has-active-chat) {
          opacity: 1;
          transform: scale(1);
          pointer-events: auto;
        }
        .connection-status {
           width: 12px;
           height: 12px;
           border-radius: 50%;
           background-color: #f87171; /* Default: Red/Error */
           margin-left: 8px;
           transition: background-color 0.3s ease;
           flex-shrink: 0; /* Prevent shrinking */
           box-shadow: 0 0 3px rgba(0,0,0,0.2);
        }
        .connection-status.connecting {
           background-color: #fbbf24;
           animation: pulse 1.5s infinite ease-in-out;
        }
        .connection-status.connected {
           background-color: #34d399;
        }
        .connection-status.ready {
           background-color: #34d399;
        }
        .connection-status.disconnected, .connection-status.closed {
           background-color: #9ca3af;
        }
        .connection-status.ended {
           background-color: #ef4444;
        }
        .connection-status.error {
           background-color: #ef4444;
           animation: pulse 1.5s infinite ease-in-out;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }

        /* AI Status Indicator (similar to typing, but distinct) */
        .ai-status-indicator {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          align-self: flex-start;
          margin-bottom: 10px;
          font-size: 13px;
          font-style: italic;
          color: #666;
          gap: 5px; /* Space between icon and text */
        }
        .ai-status-indicator svg {
          width: 14px;
          height: 14px;
          animation: spin 1s linear infinite;
          fill: #666;
          display: none; /* Hidden by default */
        }
        .ai-status-indicator.thinking svg, .ai-status-indicator.responding svg, .ai-status-indicator.searching svg {
          display: inline-block;
        }
        .ai-status-indicator.hidden { display: none; }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

        /* --- Bubble --- */
        .bubble {
          width: var(--bubble-size);
          height: var(--bubble-size);
          background: var(--ctm-chat-bubble-background, linear-gradient(135deg, var(--primary-color), var(--primary-color-dark)));
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 6px 16px rgba(0,0,0,0.2);
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative; /* For icon positioning */
          overflow: hidden; /* Ensure icons stay within bounds during transition */
        }
        
        /* Pill mode when custom text is present */
        .bubble.pill-mode:not(.open) {
          width: auto;
          height: 62px;
          border-radius: 24px;
          padding: 0 24px;
          min-width: 120px;
        }
        .bubble:hover {
          transform: scale(1.05);
          box-shadow: 0 8px 20px rgba(59, 130, 246, 0.5); /* Use primary color alpha */
        }
        .bubble.open {
          /* No separate open style needed for bubble itself now with icon transition */
        }
        .bubble svg {
          position: absolute;
          width: var(--bubble-icon-size);
          height: var(--bubble-icon-size);
          fill: var(--ctm-chat-bubble-icon-color, white);
          transition: transform 0.3s ease-out, opacity 0.3s ease-out;
        }
        .bubble-custom-content {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: absolute;
          width: 100%;
          height: 100%;
          transition: opacity 0.3s ease-out, transform 0.3s ease-out;
        }
        
        /* Horizontal layout for pill mode */
        .bubble.pill-mode:not(.open) .bubble-custom-content {
          flex-direction: row;
          gap: 8px;
          position: relative;
        }
        
        .bubble-custom-icon {
          width: var(--bubble-icon-size);
          height: var(--bubble-icon-size);
          fill: var(--ctm-chat-bubble-icon-color, white);
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        /* Larger icon in pill mode */
        .bubble.pill-mode:not(.open) .bubble-custom-icon {
          width: 24px;
          height: 24px;
        }
        
        /* Ensure SVGs inside custom icon are properly sized */
        .bubble-custom-icon svg,
        .bubble-custom-icon img {
          width: 32px;
          height: 32px;
          display: block;
        }
        
        .bubble-custom-text {
          font-size: 11px;
          font-weight: 600;
          color: var(--ctm-chat-bubble-icon-color, white);
          margin-top: 2px;
          line-height: 1;
          text-align: center;
        }
        
        /* Better text styling in pill mode */
        .bubble.pill-mode:not(.open) .bubble-custom-text {
          font-size: 16px;
          font-weight: 500;
          margin-top: 0;
          white-space: nowrap;
        }
        .bubble.open .bubble-custom-content {
          opacity: 0;
          transform: rotate(90deg) scale(0.8);
        }
        
        /* Hide default icons in pill mode */
        .bubble.pill-mode:not(.open) .bubble-icon-open,
        .bubble.pill-mode:not(.open) .bubble-icon-close {
          display: none;
        }
        
        /* Ensure pill mode reverts to circle when open */
        /*.bubble.pill-mode.open {
          width: var(--bubble-size);
          height: var(--bubble-size);
          border-radius: 50%;
          padding: 0;
        }*/
        .bubble-icon-open {
          opacity: 1;
          transform: rotate(0deg) scale(1);
        }
        .bubble-icon-close {
          opacity: 0;
          transform: rotate(-90deg) scale(0.8);
        }
        .bubble.open .bubble-icon-open {
          opacity: 0;
          transform: rotate(90deg) scale(0.8);
        }
        .bubble.open .bubble-icon-close {
          opacity: 1;
          transform: rotate(0deg) scale(1);
        }

        .engage {
          position: absolute;
          bottom: calc(var(--bubble-size) + 12px); /* Position above bubble */
          right: 0;
          background: var(--ctm-chat-engage-bg, var(--bg-color));
          color: var(--ctm-chat-engage-text-color, var(--primary-color-dark));
          font-size: 14px;
          padding: 10px 14px;
          border-radius: 12px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.15);
          opacity: 0;
          transform: translateY(10px) scale(0.95);
          pointer-events: none;
          transition: opacity 0.4s ease, transform 0.4s ease, box-shadow 0.2s ease;
          max-width: 260px;
          width: max-content;
          white-space: normal;
          line-height: 1.4;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .engage:hover {
          box-shadow: 0 6px 20px rgba(0,0,0,0.2);
        }
        
        /* Enhanced engage message with icon */
        .engage.has-icon {
          padding: 16px 20px;
          max-width: 340px;
        }
        
        .engage-icon {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          display: none;
          align-items: center;
          justify-content: center;
          background: var(--ctm-chat-engage-icon-bg, rgba(59, 130, 246, 0.1));
          border-radius: 50%;
          overflow: hidden;
          fill: var(--ctm-chat-engage-icon-color, var(--primary-color));
        }

        .engage.has-icon .engage-icon {
          display: flex;
        }

        .engage-icon svg {
          width: 28px;
          height: 28px;
        }

        .engage-icon img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .engage-text {
          flex: 1;
          text-align: left;
        }
        
        /* When no icon, text takes full width */
        .engage:not(.has-icon) .engage-text {
          text-align: center;
        }
        
        /* Close button styling */
        .engage-close {
          position: absolute;
          top: 4px;
          right: 4px;
          width: 20px;
          height: 20px;
          padding: 0;
          margin: 0;
          background: rgba(0, 0, 0, 0.1);
          border: none;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.2s ease, background 0.2s ease;
          fill: currentColor;
        }
        
        .engage:hover .engage-close {
          opacity: 1;
        }
        
        .engage-close:hover {
          background: rgba(0, 0, 0, 0.2);
        }
        
        .engage-close:active {
          background: rgba(0, 0, 0, 0.3);
        }
        .engage::after { /* Arrow */
          content: '';
          position: absolute;
          bottom: -8px;
          right: calc(var(--bubble-size) / 2 - 8px); /* Center arrow below bubble */
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid var(--ctm-chat-engage-bg, var(--bg-color));
        }
        .engage.visible {
          opacity: 1;
          transform: translateY(0) scale(1);
        }

        .chat-window {
          position: absolute;
          bottom: calc(var(--bubble-size) + 12px); /* Position above bubble */
          right: 0;
          width: var(--window-width);
          height: var(--window-height);
          max-height: var(--window-max-height);
          background: var(--bg-color);
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.2);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          opacity: 0;
          transform: translateY(20px) scale(0.95);
          pointer-events: none;
          transition: opacity 0.3s ease, transform 0.3s ease;
          color: var(--text-color);
        }
        .chat-window.open {
          opacity: 1;
          transform: translateY(0) scale(1);
          pointer-events: auto;
        }

        .header {
          background: var(--ctm-chat-header-bg, var(--primary-color-dark));
          color: var(--ctm-chat-header-text-color, white);
          padding: 0 16px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: var(--header-height);
          flex-shrink: 0; /* Prevent shrinking */
          box-sizing: border-box;
        }
        .header-title-container {
          display: flex;
          align-items: center;
          overflow: hidden; /* Prevent long titles from pushing controls */
          flex-grow: 1; /* Allow title container to take space */
          margin-right: 10px; /* Space between title/status and controls */
        }
        .header-nav-btn {
          background: none;
          border: none;
          color: inherit;
          padding: 4px;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.2s;
          margin-right: 6px;
          flex-shrink: 0;
        }
        .header-nav-btn:hover {
          opacity: 1;
        }
        .header-nav-btn svg {
          width: 18px;
          height: 18px;
          display: block;
        }
        .header-title {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .header-controls {
          display: flex;
          align-items: center;
          position: relative;
        }

        #header-close-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          box-sizing: border-box;
          padding: 0;
          margin-left: 2px;
          border-radius: 50%;
          opacity: 0.72;
        }

        #header-close-btn:hover {
          background: rgba(255,255,255,0.14);
          opacity: 1;
        }
        
        /* Hide mobile close button on desktop */
        @media (min-width: 481px) {
          .mobile-only {
            display: none !important;
          }
        }
        
        /* Show mobile close button on mobile when chat is open */
        @media (max-width: 480px) {
          #header-close-btn {
            display: none !important;
          }

          .chat-window.form-only #header-close-btn {
            display: flex !important;
          }

          .chat-window.form-only #mobile-close-btn {
            display: none !important;
          }

          :host([open="true"]) .mobile-only {
            display: block !important;
          }
        }
        
        .header-controls button {
          background: none;
          border: none;
          color: inherit;
          padding: 4px;
          cursor: pointer;
          opacity: 0.8;
          transition: opacity 0.2s;
        }
        .header-controls button:hover {
          opacity: 1;
        }
        .header-controls svg {
          width: 18px;
          height: 18px;
          display: block;
        }
        .options-menu {
          position: absolute;
          top: calc(var(--header-height) - 5px);
          right: 5px;
          background: var(--bg-color);
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          padding: 8px 0;
          z-index: 10;
          list-style: none;
          margin: 0;
          min-width: 150px;
          opacity: 0;
          transform: translateY(-10px);
          pointer-events: none;
          transition: opacity 0.2s ease, transform 0.2s ease;
        }
        .options-menu.visible {
          opacity: 1;
          transform: translateY(0);
          pointer-events: auto;
        }
        .options-menu li button {
          display: block;
          width: 100%;
          text-align: left;
          padding: 8px 16px;
          background: none;
          border: none;
          color: var(--text-color);
          font-size: 14px;
          cursor: pointer;
        }
        .options-menu li button:hover {
          background-color: rgba(0,0,0,0.05);
        }

        .messages-container {
          flex: 1; /* Take remaining space */
          overflow-y: auto;
          padding: 12px 16px;
          display: flex;
          flex-direction: column;
          background-color: var(--ctm-chat-messages-bg, #f9f9f9);
          transition: border-radius 0.3s ease, background-color 0.3s ease;
          position: relative;
        }
        .messages-container.drag-over {
          background-color: #e8f4f8;
          border: 2px dashed #3b82f6;
        }
        .messages-container.drag-over::after {
          content: "Drop images here to upload";
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 18px;
          color: #3b82f6;
          font-weight: bold;
          pointer-events: none;
        }
        /* Apply rounded bottom corners when input area is hidden */
        .chat-window.input-hidden .messages-container {
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
          /* Hide messages when AI is disabled to give full space to suggestions */
          display: none;
        }
        /* Show messages container when there are actual messages */
        .chat-window.input-hidden .messages-container:has(.message) {
          display: flex;
        }
        .message {
          margin-bottom: 10px;
          max-width: 85%;
          padding: 10px 14px;
          border-radius: 18px;
          line-height: 1.4;
          word-wrap: break-word;
          box-shadow: 0 1px 2px rgba(0,0,0,0.05);
          position: relative;
        }
        .message .timestamp {
          display:none;
        }
        .message.user {
          background: var(--ctm-chat-user-message-bg, var(--primary-color));
          color: var(--ctm-chat-user-message-text-color, white);
          align-self: flex-end;
          border-bottom-right-radius: 6px;
        }

        .message.form {
          background: var(--ctm-chat-other-message-bg, var(--bg-color));
          color: var(--ctm-chat-other-message-text-color, var(--text-color));
          align-self: flex-start;
          border-bottom-left-radius: 6px;
          border: 1px solid #eee;
          padding: 0;
          max-width: 100%;
          width: 100%;
          box-sizing: border-box;
        }
        .message.ai,
        .message.other { /* Agent, AI, System */
          background: var(--ctm-chat-other-message-bg, var(--bg-color));
          color: var(--ctm-chat-other-message-text-color, var(--text-color));
          align-self: flex-start;
          border-bottom-left-radius: 6px;
          border: 1px solid #eee;
        }
        .message.ai, .message.other .timestamp {
          float:left;
        }
        .message.status {
          font-style: italic;
          font-size: 13px;
          color: #666;
          background: transparent;
          align-self: center;
          text-align: center;
          max-width: 100%;
          padding: 4px 0;
          box-shadow: none;
          border: none;
        }
        .message.status.welcome {
          max-height: 100px;
          font-size: 16px;
          font-style: normal;
        }
        .message.system {
          font-style: italic;
          font-size: 13px;
          color: #888;
          background: #f5f5f5;
          align-self: center;
          text-align: center;
          max-width: 80%;
          padding: 8px 16px;
          box-shadow: none;
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          margin: 15px auto;
        }
        
        .message.other h1, .message.other h2, .message.other h3, .message.other h4, .message.other h5, .message.other h6 {
          margin: 16px 0 8px 0;
          font-weight: 600;
          line-height: 1.25;
        }
        .message.other h1 { font-size: 1.5em; }
        .message.other h2 { font-size: 1.3em; }
        .message.other h3 { font-size: 1.1em; }
        .message.other h4 { font-size: 1em; }
        .message.other h5 { font-size: 0.9em; }
        .message.other h6 { font-size: 0.85em; }
        
        .message.other p, .message.other ul, .message.other ol, .message.other pre, .message.other blockquote, .message.other hr, .message.other table {
          margin: 8px 0;
        }
        .message.other ul, .message.other ol {
          padding-left: 20px;
        }
        .message.other li {
          margin: 4px 0;
        }
        .message.other code {
          background: rgba(0, 0, 0, 0.05);
          padding: 2px 4px;
          border-radius: 3px;
          font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
          font-size: 0.9em;
        }
        .message.other pre {
          background: rgba(0, 0, 0, 0.05);
          padding: 12px;
          border-radius: 6px;
          overflow-x: auto;
        }
        .message.other pre code {
          background: none;
          padding: 0;
        }
        .message.other blockquote {
          border-left: 4px solid #ddd;
          padding-left: 16px;
          color: #666;
        }
        .message.other a {
          color: var(--primary-color);
          text-decoration: underline;
        }
        .message.other a:hover {
          text-decoration: none;
        }
        .message.other strong {
          font-weight: 600;
        }
        .message.other em {
          font-style: italic;
        }
        .message.other hr {
          border: none;
          border-top: 1px solid #ddd;
        }
        
        /* Citation styling */
        .message.other .citation {
          color: var(--primary-color);
          text-decoration: none;
          border-bottom: 1px solid var(--primary-color);
          transition: opacity 0.2s;
          display: inline-block;
          margin: 2px 0;
        }
        
        .message.other .citation:hover {
          opacity: 0.8;
          border-bottom-width: 2px;
        }
        
        .message.other table {
          border-collapse: collapse;
          width: 100%;
        }
        
        .message.other th,
        .message.other td {
          border: 1px solid #ddd;
          padding: 6px 12px;
          text-align: left;
        }
        
        .message.other th {
          background: rgba(0, 0, 0, 0.05);
          font-weight: 600;
        }
        .typing-indicator {
          display: flex;
          align-items: center;
          padding: 5px 10px;
          align-self: flex-start; /* Show on the 'other' side */
          margin-bottom: 10px;
        }
        .typing-indicator span {
          height: 8px;
          width: 8px;
          margin: 0 2px;
          background-color: #aaa;
          border-radius: 50%;
          display: inline-block;
          animation: bounce 1.4s infinite ease-in-out both;
        }
        .typing-indicator span:nth-child(1) { animation-delay: -0.32s; }
        .typing-indicator span:nth-child(2) { animation-delay: -0.16s; }
        @keyframes bounce {
          0%, 80%, 100% { transform: scale(0); }
          40% { transform: scale(1.0); }
        }
        .typing-indicator.hidden { display: none; }

        .suggestion-buttons {
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: var(--ctm-chat-suggestions-gap, 12px);
          padding: var(--ctm-chat-suggestions-padding, 16px 20px);
          border-top: 1px solid #f0f0f0;
          background: var(--ctm-chat-suggestions-bg, var(--bg-color));
          flex-shrink: 0; /* Prevent shrinking */
          max-height: var(
            --ctm-chat-suggestions-max-height,
            calc(var(--window-height) - var(--header-height) - var(--input-area-height) - 20px)
          );
          overflow-y: auto; /* Scroll if too many buttons */
          transition: border-radius 0.3s ease;
          box-sizing: border-box;
        }
        .chat-window.suggestions-expanded .messages-container {
          flex-grow: 0;
          flex-basis: auto;
        }
        .chat-window.suggestions-expanded .suggestion-buttons {
          flex-grow: 1;
          min-height: var(--ctm-chat-suggestions-expanded-min-height, 220px);
          max-height: var(
            --ctm-chat-suggestions-expanded-max-height,
            calc(var(--window-height) - var(--header-height) - var(--input-area-height) - 20px)
          );
        }
        /* Apply rounded bottom corners when input area is hidden */
        .chat-window.input-hidden .suggestion-buttons {
          border-bottom-left-radius: 16px;
          border-bottom-right-radius: 16px;
          /* Center suggestions vertically when AI is disabled */
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          flex: 1;
          min-height: var(--ctm-chat-suggestions-centered-min-height, 200px);
          max-height: none;
          gap: var(--ctm-chat-suggestions-centered-gap, 15px);
          padding: var(--ctm-chat-suggestions-centered-padding, 30px 20px);
          background-color: var(--ctm-chat-messages-bg, #f9f9f9);
        }
        /* Ensure buttons have consistent width when in grid layout */
        .chat-window.input-hidden .suggestion-buttons button {
          width: var(--ctm-chat-suggestion-btn-centered-width, 90%);
          max-width: var(--ctm-chat-suggestion-btn-centered-max-width, 300px);
          padding: var(--ctm-chat-suggestion-btn-centered-padding, 16px 24px);
          font-size: var(--ctm-chat-suggestion-btn-centered-font-size, 15px);
          background-color: var(--bg-color);
          border: 1px solid #e0e0e0;
          box-shadow: 0 4px 6px rgba(0,0,0,0.05);
          transition: all 0.2s ease-in-out;
          box-sizing: border-box;
        }
        .chat-window.input-hidden .suggestion-buttons button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(0,0,0,0.1);
        }
        .suggestion-buttons button {
          width: 100%;
          padding: var(--ctm-chat-suggestion-btn-padding, 12px 18px);
          font-size: 14px;
          border: 1px solid var(--ctm-chat-suggestion-btn-border-color, #e0e0e0);
          border-radius: 24px;
          background: var(--ctm-chat-suggestion-btn-bg, var(--bg-color));
          color: var(--ctm-chat-suggestion-btn-text-color, var(--primary-color));
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05);
          transition: background 0.2s ease, border-color 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          box-sizing: border-box;
        }
        .suggestion-buttons button:hover {
          background: var(--ctm-chat-suggestion-btn-hover-bg, #f9f9f9);
          border-color: var(--ctm-chat-suggestion-btn-hover-border-color, var(--primary-color));
        }

        .chat-input-area {
          display: flex;
          border-top: 1px solid #ddd;
          flex-shrink: 0; /* Prevent shrinking */
          height: var(--input-area-height);
          box-sizing: border-box;
          background: var(--bg-color);
          transition: all 0.3s ease;
        }
        .chat-input-area.hidden {
          display: none;
        }
        .chat-input-area input[type="text"] {
          flex: 1;
          border: none;
          padding: 0 16px;
          font-size: 14px;
          background: transparent;
          color: var(--text-color);
        }
        .chat-input-area input[type="text"]:focus {
          outline: none;
          box-shadow: none;
        }
        .chat-input-area input[type="text"]::placeholder {
          color: #999;
        }
        .chat-input-area input[type="text"]:disabled {
          background-color: #f5f5f5;
          cursor: not-allowed;
          color: #999;
        }
        .chat-input-area input[type="text"]:disabled::placeholder {
          color: #666;
          font-style: italic;
        }
        .chat-input-area button {
          background: var(--primary-color);
          border: none;
          color: white;
          padding: 0 18px;
          cursor: pointer;
          transition: background 0.2s;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .chat-input-area button:hover {
          background: var(--primary-color-dark);
        }
        .chat-input-area button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }
        .chat-input-area button svg {
          width: 20px;
          height: 20px;
          fill: currentColor;
        }

        /* --- Responsive Adjustments --- */
        
        /* Tablet devices */
        @media (max-width: 768px) {
          :host {
            --window-width: min(400px, calc(100vw - 48px));
            --window-height: min(600px, calc(100vh - 120px));
            --ctm-chat-right-offset: 20px;
            --ctm-chat-bottom-offset: 20px;
          }
          
          .chat-window {
            font-size: 15px; /* Slightly smaller font for better fit */
          }
          
          .message {
            max-width: 90%; /* More width for messages */
          }
        }
        
        /* Mobile landscape */
        @media (max-width: 667px) and (orientation: landscape) {
          :host {
            --window-height: calc(100vh - 80px); /* Use more vertical space */
            --window-max-height: calc(100vh - 80px);
          }
          
          .chat-window {
            bottom: 8px; /* Reduce spacing in landscape */
          }
          
          .messages-container {
            padding: 8px 12px; /* Reduce padding */
          }
        }
        
        /* Small mobile devices */
        @media (max-width: 480px) {
          :host {
            --window-width: 100vw;
            --window-height: 100vh;
            --window-max-height: 100vh;
            --ctm-chat-right-offset: 0;
            --ctm-chat-bottom-offset: 0;
            --bubble-size: 56px;
            --bubble-icon-size: 24px;
          }
          
          /* Full screen chat window on mobile */
          .chat-window {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            width: 100vw;
            height: 100vh;
            max-height: 100vh;
            border-radius: 0;
            box-shadow: none;
          }
          
          /* Adjust bubble position on mobile */
          .bubble {
            bottom: 20px;
            right: 20px;
            z-index: 10000;
          }
          
          /* Show engage message on mobile devices */
          .engage {
            display: block !important;
            bottom: calc(56px + 32px); /* Position above mobile bubble */
            right: 20px;
            max-width: calc(100vw - 40px);
            font-size: 14px;
          }
          
          .engage::after {
            right: 28px; /* Align arrow with bubble center on mobile */
          }
          
          /* Mobile-optimized header */
          .header {
            padding: 0 12px;
            height: 48px;
            --header-height: 48px;
          }
          
          .header-title {
            font-size: 16px;
          }
          
          /* Mobile-optimized messages */
          .messages-container {
            padding: 10px 12px;
            /* Add safe area padding for devices with notches */
            padding-left: max(12px, env(safe-area-inset-left));
            padding-right: max(12px, env(safe-area-inset-right));
          }
          
          .message {
            max-width: 85%;
            font-size: 15px;
            padding: 8px 12px;
          }
          
          /* Full width for form messages on mobile */
          .message.form {
            max-width: 100%;
            margin: 0;
            padding: 0;
          }
          
          /* When form is present and keyboard is active, adjust layout */
          .chat-window.keyboard-active .messages-container:has(.message.form) {
            padding-bottom: 20px;
          }
          
          /* When form is displayed, ensure messages container uses full height */
          .chat-window .messages-container:has(.message.form) {
            height: calc(100vh - var(--header-height));
            max-height: calc(100vh - var(--header-height));
            overflow-y: auto;
            padding: 0;
          }
          
          /* Hide input area when form is present on mobile */
          .chat-window:has(.message.form) .chat-input-area {
            display: none;
          }
          
          /* Optimize suggestion buttons for mobile */
          .suggestion-buttons {
            padding: 8px 12px;
            gap: 6px;
            max-height: 100px;
            /* Ensure they're scrollable with touch */
            -webkit-overflow-scrolling: touch;
            overflow-x: auto;
            overflow-y: hidden;
          }
          
          /* When input is hidden on mobile, adjust suggestion buttons to avoid widget overlap */
          .chat-window.input-hidden .suggestion-buttons {
            /* Override the centered layout for mobile */
            padding-bottom: calc(56px + 40px); /* Account for bubble size + spacing */
            min-height: auto;
            flex: 1;
            border-radius: 0; /* Remove rounded corners on full screen mobile */
            overflow: hidden; /* Prevent scroll within suggestions container */
            position: relative;
          }
          
          /* Prevent scrolling issues on mobile when input is hidden */
          .chat-window.input-hidden {
            overflow: hidden;
          }
          
          /* Show messages container only if it has any messages */
          .chat-window.input-hidden .messages-container {
            display: none !important;
          }
          
          /* But show it if there are any messages */
          .chat-window.input-hidden .messages-container:has(.message) {
            display: flex !important;
            flex: 1; /* Allow it to grow to fill space */
            padding: 12px 16px;
            background-color: transparent;
            border-bottom: none;
          }
          
          .suggestion-buttons button {
            font-size: 13px;
            padding: 6px 12px;
            white-space: nowrap;
            flex-shrink: 0;
          }
          
          /* Mobile-optimized input area */
          .chat-input-area {
            height: 52px;
            --input-area-height: 52px;
            padding: 0;
            /* Add safe area padding for devices with notches */
            padding-bottom: env(safe-area-inset-bottom);
          }
          
          .chat-input-area input[type="text"] {
            font-size: 16px; /* Prevent zoom on iOS */
            padding: 0 12px;
          }
          
          .chat-input-area button {
            padding: 0 16px;
            min-width: 52px;
          }
          
          /* Optimize dropdowns for mobile */
          .options-menu {
            right: 10px;
            top: 45px;
            min-width: 140px;
          }
        }
        
        /* Very small devices */
        @media (max-width: 400px) {
          :host {
             --window-width: calc(100vw - 32px); /* Adjust width on small screens */
             --ctm-chat-right-offset: 16px;
             --ctm-chat-bottom-offset: 16px;
             --bubble-size: 56px;
             --bubble-icon-size: 24px;
          }
        }
        
        /* Keyboard active state for mobile */
        .chat-window.keyboard-active {
          transition: height 0.3s ease-out, top 0.3s ease-out;
        }
        
        .chat-window.keyboard-active .messages-container {
          transition: height 0.3s ease-out;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }
        
        /* Touch-friendly adjustments */
        @media (hover: none) and (pointer: coarse) {
          /* Increase touch targets */
          .bubble {
            --bubble-size: 60px;
          }
          
          .header-controls button {
            padding: 8px;
            min-width: 44px;
            min-height: 44px;
          }
          
          .suggestion-buttons button {
            min-height: 44px;
            padding: 10px 16px;
          }
          
          .chat-input-area button {
            min-width: 56px;
          }
          
          /* Remove hover effects on touch devices */
          .bubble:hover {
            transform: none;
            box-shadow: 0 6px 16px rgba(0,0,0,0.2);
          }
          
          .suggestion-buttons button:hover {
            background: var(--ctm-chat-suggestion-btn-bg, var(--bg-color));
            border-color: var(--ctm-chat-suggestion-btn-border-color, #e0e0e0);
          }
          
          /* Add active states for better touch feedback */
          .bubble:active {
            transform: scale(0.95);
          }
          
          .suggestion-buttons button:active {
            background: var(--ctm-chat-suggestion-btn-hover-bg, #f9f9f9);
            transform: scale(0.95);
          }
          
          .chat-input-area button:active {
            transform: scale(0.95);
          }
          
          /* Improve scrolling performance */
          .messages-container {
            -webkit-overflow-scrolling: touch;
            scroll-behavior: smooth;
          }
        }

        /*
         * Restore configured dimensions for page-positioned widgets even when
         * the outer page matches the mobile media queries above.
         */
        :host([placement="contained"]),
        :host([placement="natural"]) {
          --window-width: var(--ctm-chat-window-width, var(--ctm-chat-window-width-default));
          --window-height: var(--ctm-chat-window-height, var(--ctm-chat-height-width-default));
          --window-max-height: var(--ctm-chat-window-max-height, var(--window-height));
        }

        :host([placement="contained"]) .bubble {
          position: absolute;
          bottom: var(--ctm-chat-bottom-offset, 24px);
          right: var(--ctm-chat-right-offset, 24px);
        }

        :host([placement="natural"]) .bubble {
          position: relative;
          bottom: auto;
          right: auto;
        }

        :host([placement="contained"]) .engage {
          bottom: calc(
            var(--ctm-chat-bottom-offset, 24px) + var(--bubble-size) + 12px
          );
          right: var(--ctm-chat-right-offset, 24px);
        }

        :host([placement="natural"]) .engage {
          bottom: calc(var(--bubble-size) + 12px);
          right: 0;
        }

        :host([placement="contained"]) .chat-window,
        :host([placement="natural"]) .chat-window {
          position: absolute;
          top: auto;
          left: auto;
          width: var(--window-width);
          height: var(--window-height);
          max-height: var(--window-max-height);
          border-radius: 16px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.2);
        }

        /*
         * Contained placement additionally clamps the open window to the
         * positioned ancestor. Natural placement intentionally omits these
         * limits so the window can overlap surrounding page content.
         */
        :host([placement="contained"]) .chat-window {
          right: var(--ctm-chat-right-offset, 24px);
          bottom: calc(
            var(--ctm-chat-bottom-offset, 24px) + var(--bubble-size) + 12px
          );
          max-width: calc(100% - var(--ctm-chat-right-offset, 24px) - 16px);
          max-height: min(
            var(--window-max-height),
            calc(
              100% - var(--ctm-chat-bottom-offset, 24px) -
              var(--bubble-size) - 28px
            )
          );
        }

        :host([placement="natural"]) .chat-window {
          right: 0;
          bottom: calc(var(--bubble-size) + 12px);
        }

        /*
         * Supported browsers promote the natural chat window into the HTML
         * top layer so ancestor overflow and stacking contexts cannot clip it.
         */
        :host([placement="natural"]) .chat-window:popover-open {
          position: fixed;
          inset: auto;
          margin: 0;
          padding: 0;
          border: 0;
        }

        :host([placement="natural"]) .chat-window::backdrop {
          background: transparent;
          pointer-events: none;
        }
        
        /* Accessibility improvements for mobile */
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
            scroll-behavior: auto !important;
          }
        }
    `;
  }
}
